@if (pdfDetails) {
  @if (pageIncluded(PDFPageKeys.RISKS_OPPORTUNITIES)) {
    <app-pdf-page-risks-and-opportunities [pdfDetails]="pdfDetails" [options]="pageOptions(PDFPageKeys.RISKS_OPPORTUNITIES)" [clientOnly]="false"></app-pdf-page-risks-and-opportunities>
  }
  @if (pageIncluded(PDFPageKeys.RISKS_OPPORTUNITIES_CLIENT)) {
    @if (needPageBreak(PDFPageKeys.RISKS_OPPORTUNITIES_CLIENT)) {
      <app-pdf-pagebreak></app-pdf-pagebreak>
    }
    <app-pdf-page-risks-and-opportunities [pdfDetails]="pdfDetails" [options]="pageOptions(PDFPageKeys.RISKS_OPPORTUNITIES_CLIENT)" [clientOnly]="true"></app-pdf-page-risks-and-opportunities>
  }
}
